import { InjectionToken } from '@angular/core';

export const VERSION_CHECK_INTERVAL_TIME = new InjectionToken<number>('version.check.interval.time');